// extracted by mini-css-extract-plugin
var _1 = "F_kYHv";
var _2 = "f05FnH";
var _3 = "qysqg2";
var _4 = "CHKmKb";
var _5 = "qOvQhG";
var _6 = "Jor52R";
var _7 = "ktWX2v";
var _8 = "CNLjap";
var _9 = "riLD5M";
var _a = "OmlTfQ";
var _b = "HyTweh";
export { _1 as "active", _2 as "ease-transition", _3 as "gradient-titanic-80", _4 as "handle", _5 as "linear-transition-05", _6 as "shadow-medium-titanic", _7 as "shadow-medium-titanic-hover", _8 as "shadow-titanic-1", _9 as "shadow-white", _a as "size-20", _b as "switch" }
